//#region Imports and Global Definitions
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { StyleSheet, View, SafeAreaView, Platform, useWindowDimensions, Pressable, FlatList, TouchableOpacity } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from '../../../../styles/commonStyles';
import CustomLabel from '../../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../../components/CustomInput';
import CustomButton from '../../../../components/CustomButton';
import { ActivityIndicator, Card } from 'react-native-paper';
import { showMessage } from "react-native-flash-message";
import HRAdminServiceLinesScreen from './HRAdminServiceLinesScreen';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import CustomDropDown from '../../../../components/CustomDropDown/CustomDropdown'
import { useCompany } from '../../../../hooks/useCompany';
import Swal from 'sweetalert2';
// * Language
import { useTranslation } from 'react-i18next';
import { useSettingsContext } from '../../../../hooks/useSettingsContext';
import { useTableHelper } from '../../../../hooks/useTableHelper';

var _ = require('lodash');


const NumberInput = ({ index, item, itemKey, handleEditPress }) => {
    const [number, setNumber] = useState(null);
    return (
        <CustomInput
            defaultValue={item[itemKey]}
            value={number}
            setValue={e => {
                let onlyNum = e.replace(/[^0-9.]/g, ''); // allows numbers and dots
                let dotIndex = onlyNum.indexOf('.');
                if (dotIndex !== -1) onlyNum = onlyNum.slice(0, dotIndex + 1) + onlyNum.slice(dotIndex + 1).replace(/\./g, '');
                setNumber(onlyNum);
                handleEditPress(index, item, itemKey, onlyNum)
            }}
            maxLen={50}
            type="MAININPUT"
            keyboardType='numeric'
        />
    );
};

const FunctionListView = React.memo(({ item, index, handleEditPress, showServiceLines, employees,
    handleDeleteFunction, handlePress, styles, d365, duplicates, insertData, hasChildren
}) => {

    let errorMark = false;
    let errorAttr = '';

    duplicates.forEach(duplicate => {
        if (duplicate.attrVal.includes(item[duplicate.attribute])) {
            errorMark = true;
            errorAttr = duplicate.attrVal;
        }
    });

    return (
        <SafeAreaView>
            {showServiceLines ?
                <SafeAreaView
                    style={[{ alignContent: 'center' }]}>
                    <CustomLabel
                        value={item.description === "" ? item.servCode.toUpperCase() : item.description.toUpperCase()}
                        type="BRANCHES_WHEN_SHOWING_LOCATIONS" />

                </SafeAreaView>
                :
                <SafeAreaView style={styles.row}>
                    <View
                        style={[styles.item, { justifyContent: 'flex-start' }]}>
                        <CustomInput
                            value={item.servCode}
                            setValue={(e) => handleEditPress(index, item, 'servCode', e)}
                            maxLen={3}
                            type={errorMark && errorAttr === item.servCode ? "MISSING_DEPARTMENT_CODE" : "MAININPUT"}
                            editable={showServiceLines ? false : true}
                        />
                    </View>
                    <View
                        style={[styles.item]}>
                        <CustomInput
                            value={item.description}
                            setValue={(e) => handleEditPress(index, item, 'description', e)}
                            maxLen={50}
                            type="MAININPUT"
                            editable={showServiceLines ? false : true}
                        />
                    </View>
                    {employees.length > 0 &&
                        <View
                            style={[styles.item]}>
                            <CustomDropDown
                                defValue={item?.headOfFunction}
                                options={employees}
                                value={item?.headOfFunction}
                                type="SERVICE_LINES"
                                setValue={(e) => handleEditPress(index, item, 'headOfFunction', e)}
                            />
                        </View>
                    }
                    <View
                        style={[styles.item]}>
                        <NumberInput
                            index={index}
                            item={item}
                            itemKey="exceedInvAmount"
                            handleEditPress={handleEditPress}
                        />
                    </View>
                    <View
                        style={[styles.item]}>
                        <CustomInput
                            value={item.regionalCode}
                            setValue={(e) => handleEditPress(index, item, 'regionalCode', e)}
                            maxLen={3}
                            type="MAININPUT"
                            editable={showServiceLines ? false : true}
                        />
                    </View>
                    {d365 &&
                        <View
                            style={[styles.item]}>
                            <CustomInput
                                value={item.d365Code}
                                setValue={(e) => handleEditPress(index, item, 'd365Code', e)}
                                maxLen={50}
                                type="MAININPUT"
                                editable={showServiceLines ? false : true}
                            />
                        </View>
                    }
                    <SafeAreaView>
                        {!hasChildren[item.functionID] &&
                            <CustomButton
                                iconName='trash-outline'
                                onPress={() => {
                                    handleDeleteFunction(item, index, 'functionID')
                                }}
                                show='HOME_BELL'
                                type='HOME_BELL'
                                textTop='2'
                                sz={30} />
                        }
                        {!insertData.includes(item.functionID) &&
                            <CustomButton
                                iconName='ellipsis-vertical-outline'
                                onPress={() => {
                                    handlePress(item, index)
                                }}
                                show='HOME_BELL'
                                type='HOME_BELL'
                                textTop='2'
                                sz={30} />
                        }
                    </SafeAreaView>
                </SafeAreaView>
            }
        </SafeAreaView>
    )
})

const HRAdminFunctionsScreen = (props) => {

    //#region Props
    const { selectedCompany, showServiceLines, setShowServiceLines, showDepartments, setShowDepartments } = props;
    //#endregion

    //#region Const Definitions
    const { width, height } = useWindowDimensions();
    const { colors } = useTheme();
    const { d365 } = useSettingsContext()
    const styles = makeStyles(colors, width);
    const common = createCommonStyles(colors);
    const [isLoading, setIsLoading] = useState(true);
    const [functionsData, setFunctionsData] = useState([]);
    const [changes, setChanges] = useState({});
    const [noChangesFunctions, setOriginalData] = useState([]);
    const [selectedFunction, setSelectedFunction] = useState(null);
    const [refreshAfterSave, setRefreshAfterSave] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const [employees, setEmployees] = useState([]);
    const [buttonStates, setButtonStates] = useState({
        pressed: {}
    })
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [duplicates, setDuplicates] = useState([])
    const [hasChildren, setHasChildren] = useState([]);
    const [deletedItems, setDeletedItems] = useState([])
    const [insertData, setInsertData] = useState([]);
    const { getFunctionsData, getAllEmployees, insertFunction, updateFunctions, deleteFunction, getServiceLines } = useCompany();
    const { rowEdit, rowDelete, rowAdd, handleCancelChanges, hasDuplicates } = useTableHelper();
    const prevSelectedCompany = useRef();
    const ref = useRef(null);
    const companyRef = useRef(null);

    //#endregion

    //#region Language
    const { t, i18n } = useTranslation();
    //#endregion

    //#region UseEffect

    useEffect(() => {
        if (!refreshAfterSave && companyRef.current === selectedCompany) return;
        companyRef.current = selectedCompany;

        getFunctionsData(selectedCompany).then((arr) => {
            setChanges({});
            setFunctionsData(arr);
            setOriginalData([...arr])
            setIsLoading(true);
            if (prevSelectedCompany.current != selectedCompany) { // only call the below if company changed
                getAllEmployees(selectedCompany)
                    .then((data) => {
                        prevSelectedCompany.current = selectedCompany;
                        setEmployees([...data]);
                        getServiceLines(selectedCompany)
                            .then((res) => {
                                const matchedFunctionIDs = arr.reduce((acc, funct1) => {
                                    const match = res.data.some(funct2 => funct2.topServCode === funct1.servCode);
                                    acc[funct1.functionID] = match ? funct1.servCode : undefined;
                                    return acc;
                                }, {});
                                setHasChildren(matchedFunctionIDs)
                                setRefreshAfterSave(false);
                                setIsLoading(false);
                            }).catch(() => {
                                setRefreshAfterSave(false);
                                setIsLoading(false);
                            })
                    }).catch(() => {
                        setRefreshAfterSave(false);
                        setIsLoading(false);
                    });
            }
            else {
                setRefreshAfterSave(false);
                setIsLoading(false);
            }
        }).catch(() => {
            setRefreshAfterSave(false);
        })
    }, [selectedCompany, refreshAfterSave])

    //#endregion

    //#region Helpers

    const resetPressedKey = () => {
        setButtonStates((prevState) => {
            const newPressedState = Object.keys(prevState.pressed).reduce((acc, key) => {
                acc[key] = false;
                return acc;
            }, {});

            return {
                ...prevState,
                pressed: newPressedState,
            };
        });
    };

    const validateInput = () => {
        let ret = [true, t('common:validationSuccess')]
        functionsData.forEach((itr) => {
            if (itr.servCode === '' || !itr.hasOwnProperty('servCode'))
                ret = [false, t('common:mandatoryCodeNotGivenFunctions')];
            // * Check empty description
            if (itr.description === '')
                ret = [false, t('common:descEmpty')]

        })
        return (ret)
    }

    const removeFromChangesAfterSave = () => {
        setChanges([])
        setDeletedItems([])
    }

    const checkIfUnsavedChanges = (hasChanges) => {
        setHasUnsavedChanges(hasChanges);
    }

    // const toggleVisibility = () => {
    //     setIsVisible(false);
    // };

    //#endregion

    //#region Handlers

    const handleEditPress = useCallback((index, item, key, value) => {
        if (item[key] === value) return;
        rowEdit(index, item, key, value, changes, setChanges, functionsData, setFunctionsData)
    }, []);

    const handleSave = async () => {
        let newPromises = [];
        let deleteSucc = { status: true, message: "" };
        let insertSucc = true;
        let updateSucc = true;

        if (Object.entries(changes).length == 0 && deletedItems.length == 0) {
            showMessage({
                message: t('common:noChanges'),
                type: "danger",
                duration: 3000,
            })
            return
        }

        let valid = true;
        const attributesToIgnore = [
            'description', 'headOfFunction', 'exceedInvAmount',
            'regionalCode', 'd365Code', 'oldFunctionID', 'servLinesCnt', 'functionID'
        ];

        if (functionsData.length > 0)
            Object.keys(functionsData[0]).forEach(key => {
                //* Ignore Keys that we know can be duplicated 
                if (!attributesToIgnore.includes(key)) {
                    if (hasDuplicates(functionsData, key, setDuplicates)) {
                        showMessage({
                            message: t('common:duplicates'),
                            type: "danger",
                            duration: 3000,
                        })
                        // * Abort Save if this is triggered.
                        valid = false;
                    }
                }
            });

        if (!valid)
            return null;

        let valRet = validateInput();
        if (!valRet[0]) {
            showMessage({
                message: valRet[1],
                type: "danger",
                duration: 3000,
            })
            return;
        }

        let dataForInsert = [];
        let dataForUpdate = [];

        Object.entries(functionsData).forEach(([key, obj]) => {
            if (insertData.includes(obj.functionID)) {
                dataForInsert.push(obj);
            } else {
                dataForUpdate.push(obj);
            }
        });

        if (Object.keys(dataForUpdate).length > 0) {
            newPromises.push(updateFunctions(dataForUpdate, selectedCompany)
                .then((res) => {
                    if (!res) updateSucc = false;
                    removeFromChangesAfterSave()
                })
                .catch(() => { }));
        }
        if (Object.keys(dataForInsert).length > 0) {
            newPromises.push(insertFunction(dataForInsert, selectedCompany)
                .then((res) => {
                    if (!res) insertSucc = false;
                    removeFromChangesAfterSave()
                })
                .catch(() => { }));
        }
        if (deletedItems.length > 0) {
            newPromises.push(deleteFunction(deletedItems).then((res) => {
                if (!res) deleteSucc = false;
                removeFromChangesAfterSave()
            })
                .catch(() => { }));
        }

        try {
            await Promise.all(newPromises).then(() => {
                if (!insertSucc || !deleteSucc['status'] || !updateSucc) {
                    if (!deleteSucc['status'] && deleteSucc['message'] !== "") {
                        showMessage({
                            message: t('common:functionWithServLinesDeleteMess'),
                            type: "danger",
                            duration: 3000,
                        })
                        let removeDeleteBranches = Object.fromEntries(Object.entries(changes).filter(([key, value]) =>
                            value.isDeleted !== true)
                        )
                        setChanges(removeDeleteBranches);
                    }
                    else {
                        showMessage({
                            message: t('common:issueMessage'),
                            type: "error",
                            duration: 3000,
                        })
                    }
                }
                else if (insertSucc && deleteSucc['status'] && updateSucc) {
                    showMessage({
                        message: t('common:allOperationsSuccMess'),
                        type: "success",
                        duration: 3000,
                    })
                    setDuplicates([]);
                    setRefreshAfterSave(true);
                }
            });
        } catch (error) {
            setRefreshAfterSave(true);
            setDuplicates([]);
        }
    }

    const handleDeleteFunction = (item, index, attribute) => {
        rowDelete(item, index, attribute, changes, setChanges, functionsData, setFunctionsData, setDeletedItems, ref)
    }

    const handleAddNewFunction = () => {
        let temp = [...functionsData];
        if (functionsData.length === 0)
            temp = {
                servCode: "",
                description: "",
                headOfFunction: "",
                exceedInvAmount: undefined,
                regionalCode: "",
                d365Code: "",
                oldFunctionID: "",
                functionID: ""
            }
        rowAdd(temp, setFunctionsData, ['functionID'], [], ref, t, [], [], undefined, undefined, insertData, setInsertData, id = 'functionID',);
    }

    const handlePress = (item, index) => {
        if (!showServiceLines) {
            setShowServiceLines(!showServiceLines);
        }
        setSelectedFunction(item.servCode);
        if (selectedFunction === item.servCode && showServiceLines)
            return;
        setButtonStates((prevState) => {
            const newPressedState = Object.keys(prevState.pressed).reduce((acc, key) => {
                acc[key] = false;
                return acc;
            }, {});
            newPressedState[index] = !prevState.pressed[index];
            return {
                ...prevState,
                pressed: newPressedState,
            };
        });
    }

    const handleGoBack = (showServLines = null) => {
        if (showServLines === true) {
            setShowServiceLines(true);
            setIsVisible(true);
            return;
        }
        if (showServiceLines) {
            setShowServiceLines(false);
            resetPressedKey();
        }
        setRefreshAfterSave(true);
    }

    //#endregion

    //#region Components

    const renderData = (item, index) => {
        return (
            <FunctionListView item={item} index={index}
                handleEditPress={handleEditPress}
                showServiceLines={showServiceLines}
                employees={employees}
                handleDeleteFunction={handleDeleteFunction}
                handlePress={handlePress}
                duplicates={duplicates}
                styles={styles}
                d365={d365}
                hasChildren={hasChildren}
                insertData={insertData}
            />
        )
    }
    const renderFunctions = useCallback((item, index) => {
        if (showServiceLines)
            return renderPressableFunctions(item, index);
        return (
            <Card
                style={[common.cardstyle]} >
                <Card.Content>
                    {renderData(item, index)}
                </Card.Content>
            </Card >
        )

    }, [functionsData, buttonStates, duplicates, hasChildren, hasUnsavedChanges, showServiceLines]);

    const renderPressableFunctions = (item, index) => {
        if (hasUnsavedChanges)
            return (
                <View
                    style={styles.button}>
                    <TouchableOpacity
                        onPress={() => {
                            if (Platform.OS === 'web') {
                                Swal.fire({
                                    title: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:changeFunctionMessage')}</text>`,
                                    icon: "warning",
                                    showCancelButton: true,
                                    reverseButtons: true,
                                    cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:cancel')}</text>`,
                                    cancelButtonColor: '#d3d3d3',
                                    confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:confirmMessage')}</text>`,
                                    confirmButtonColor: '#A0A2FF',
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        setHasUnsavedChanges(false);
                                        handlePress(item, index);
                                    };
                                });
                            }
                        }}>
                        <View>
                            <Card
                                style={[common.cardstyle, buttonStates.pressed[index] === true ? [common.cardstyle, styles.selectedButton] : null]} >
                                <Card.Content>
                                    {renderData(item, index)}
                                </Card.Content>
                            </Card>
                        </View>
                    </TouchableOpacity>
                </View >
            )
        else
            return (
                <Pressable onPress={() => { handlePress(item, index) }}>
                    <Card
                        style={[common.cardstyle, buttonStates.pressed[index] === true ? [common.cardstyle, styles.selectedButton] : null]} >
                        <Card.Content>
                            {renderData(item, index)}
                        </Card.Content>
                    </Card>
                </Pressable>
            )
    };
    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )
    //#endregion

    return (
        <SafeAreaView style={styles.mainView}>
            {(showServiceLines && !showDepartments) &&
                <TouchableOpacity onPress={() => { handleGoBack() }} style={styles.backButton}>
                    <Ionicons name="arrow-back" size={30} color="black" />
                </TouchableOpacity>
            }
            <SafeAreaView style={styles.rowView}>
                <SafeAreaView style={[styles.subMain]}>
                    {selectedCompany &&
                        <View style={styles.innerView}>
                            {!showServiceLines &&
                                <View style={[styles.buttons, styles.functionalityButtons]}>
                                    <CustomButton
                                        text={t('common:createNewFunction')}
                                        onPress={() => { handleAddNewFunction(selectedFunction) }}
                                        type='BUTTON_ADD'
                                        textTop='0'
                                        sz={15}
                                    />
                                    {(Object.keys(changes).length > 0 ||
                                        functionsData.length > 0 ||
                                        deletedItems.length > 0) &&
                                        <CustomButton
                                            text={t('common:saveFunction')}
                                            onPress={() => { handleSave() }}
                                            type='BUTTON_SAVE'
                                            textTop='0'
                                            isGradient={true}
                                            sz={15}
                                        />
                                    }
                                    <CustomButton
                                        text={t('common:cancel')}
                                        onPress={() => {
                                            handleCancelChanges(setFunctionsData, noChangesFunctions, setDeletedItems, setChanges, setDuplicates);
                                        }}
                                        type="BUTTON_CANCEL"
                                        textTop='0'
                                        sz={15}
                                    />
                                </View>
                            }
                            <View style={styles.functionsView}>
                                <FlatList
                                    style={showServiceLines ? !showDepartments ? styles.fullHeight : { display: 'none' } : styles.fullWidth}
                                    data={functionsData}
                                    keyExtractor={(item, index) => `${item.functionID}-${index}`}
                                    renderItem={({ item, index }) =>
                                        renderFunctions(item, index)
                                    }
                                    scrollEnabled={true}
                                    refreshing={isLoading}
                                    ref={ref}
                                    ListHeaderComponent={
                                        !showServiceLines &&
                                        <SafeAreaView style={common.listTitle}>
                                            <View style={[styles.row, { marginRight: '3%', }]}>
                                                <CustomLabel
                                                    value={t('common:function')}
                                                    type='SUBTITLE' />
                                                <CustomLabel
                                                    value={t('common:description')}
                                                    type='SUBTITLE' />
                                                {employees.length > 0 &&
                                                    <CustomLabel
                                                        value={t('common:headOfFunction')}
                                                        type='SUBTITLE' />
                                                }
                                                <CustomLabel
                                                    value={t('common:exceedInvAmount')}
                                                    type='SUBTITLE' />
                                                <CustomLabel
                                                    value={t('common:regionalCode')}
                                                    type='SUBTITLE' />
                                                {d365 &&
                                                    <CustomLabel
                                                        value={t('common:d365Code')}
                                                        type='SUBTITLE' />
                                                }
                                            </View>
                                            <SafeAreaView style={common.divider} />

                                        </SafeAreaView>
                                    }
                                    ListEmptyComponent={
                                        isLoading ?
                                            <ActivityIndicator animating={true} color={colors.blue} />
                                            :
                                            <CustomLabel
                                                value={t("common:functionsNoDataPreview")}
                                                type="NO_FUNCTIONS"
                                            />
                                    }
                                    initialNumToRender={4}
                                />
                                {showServiceLines ?
                                    <SafeAreaView style={!showDepartments ? styles.servLinesView : { width: '100%', }}>
                                        <HRAdminServiceLinesScreen
                                            props={{
                                                companyEmployees: employees,
                                                goBackFunctions: handleGoBack,
                                                // toggleVisibility: toggleVisibility,
                                                selectedCompany: selectedCompany,
                                                selectedFunction: selectedFunction,
                                                checkIfUnsavedChangesInServLines: checkIfUnsavedChanges,
                                                showDepartments: showDepartments,
                                                setShowDepartments: setShowDepartments,
                                                changes: changes,
                                                setChanges: setChanges
                                            }}
                                        />
                                    </SafeAreaView>
                                    : <></>
                                }
                            </View>
                        </View>
                    }
                </SafeAreaView>
            </SafeAreaView >
        </SafeAreaView >
    )
};

//#region Styles
const makeStyles = (colors, width, isDepartmentsShowing) => StyleSheet.create({
    mainView: {
        flex: 1,
    },
    subMain: {
        borderRadius: 35,
        elevation: (Platform.OS === 'web' && width > 992 ? 3 : 0),
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.1,
        width: '100%'
    },
    rowView: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center'
    },
    row: {
        flex: 1,
        flexDirection: "row",
        alignItems: 'center',
    },
    item: {
        flex: 1,
    },
    error: {
        color: colors.validation_error,
        alignSelf: 'center',
        fontSize: 14,
    },
    selectedButton: {
        margin: 10,
        borderWidth: 2,
        borderColor: colors.buttons_submit,
    },
    backButton: {
        alignSelf: 'flex-end',
        margin: 0
    },
    innerView: {
        flex: 1,
    },
    functionsView: {
        flexDirection: 'row',
        height: '100%'
    },
    fullHeight: {
        height: '95%',
    },
    fullWidth: {
        height: '85%',
    },
    servLinesView: {
        width: '85%',
        height: '100%',
    },
    functionalityButtons: {
        justifyContent: 'flex-end'
    },
    buttons: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        width: '50%',
        alignSelf: 'flex-end',
    },
    loader: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '4%'
    },
});


//#endregion

export default HRAdminFunctionsScreen;